module.exports = __webpack_public_path__ + "assets/img/download-e92c9b65.png";